import { useRef } from "react";
import { FormattedMessage } from "react-intl";

import StartBreakReasonForm from "./start-break-reason-form";

import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import BreakReasonTimer from "./break-reason-timer";
import ClearIcon from '@mui/icons-material/Clear';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import { Button, DialogActions } from "@mui/material";

import { Timer as TimerIcon } from "@mui/icons-material";

export default function BreakReasonStartDialog(props) {
  const {
    open,
    handleOpenOrClose,
    classes,
    setState,
    isFinishingBreak = false,
    loading,
    onAfter = null,
  } = props;

  const breakReasonFormRef = useRef(null);

  if (!open || loading) {
    return null;
  }

  async function handleSave() {
    const isValid = await breakReasonFormRef.current?.submitForm();

    if (!isValid) return;

    if (onAfter) {
      await onAfter();
    }
  }

  return (
    <Dialog
      open={open}
      onClose={handleOpenOrClose}
      aria-labelledby="newuser-dialog-title"
      scroll="paper"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle id="newuser-dialog-title" sx={{ pb: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <TimerIcon fontSize="medium" />
            <Typography variant="h6" fontWeight={"bold"}><FormattedMessage id="menu.register.break" /></Typography>
          </Box>
          <IconButton aria-label="close" size="small" onClick={handleOpenOrClose}>
            <ClearIcon fontSize="small" />
          </IconButton>
        </Box>
      </DialogTitle>

      <BreakReasonTimer
        timerStyleType="page"
        setState={setState}
        onClose={handleOpenOrClose}
        onAfterHandleFinishBreak={onAfter}
        isFinishingBreak={isFinishingBreak}
      >
        <DialogContent
          dividers
          sx={{
            width: '100%',
            minHeight: '100px',
            p: 0
          }}
        >
          <StartBreakReasonForm
            ref={breakReasonFormRef}
            classes={classes}
            onClose={handleOpenOrClose}
            setState={setState}
          />

        </DialogContent>

        <DialogActions>
          <Button
            color="primary"
            onClick={handleOpenOrClose}
            sx={{ minWidth: 100 }}
          >
            <FormattedMessage id="close" />
          </Button>

          <Button
            type="submit"
            variant="contained"
            color="primary"
            onClick={handleSave}
            sx={{ minWidth: 100 }}
          >
            {<FormattedMessage id="save" />}
          </Button>
        </DialogActions>
      </BreakReasonTimer>
    </Dialog>
  );
}
